/* eslint-disable no-underscore-dangle */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Typography,
  Switch,
  Grid,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import Select from 'react-select';
import MomentUtils from '@date-io/moment';
import {
  KeyboardDatePicker,
  KeyboardDateTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { makeStyles } from '@material-ui/core/styles';
import useExam from './useExam';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    marginBottom: 20,
    marginLeft: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px',
  },
}));

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused || state.isSelected ? '#deebff' : 'white',
    color: 'black',
    width: '100%',
    fontSize: '14px',
  }),
  control: (base, state) => ({
    ...base,
    minHeight: '56px',
    marginTop: '16px',
    fontSize: '16px',
    boxShadow: state.isFocused ? '0 0 0 1px #002984' : 0,
  }),
  menu: (provided) => ({ ...provided, zIndex: 98 }),
};

const today = new Date();
const minDate = new Date(today.getFullYear(), today.getUTCMonth(), today.getDate() + 21, 9, 0, 0, 0);
const maxDate = new Date(today.getFullYear(), today.getUTCMonth(), today.getDate() + 21, 10, 0, 0, 0);
const durations = [{ label: '30min', value: 30 }, { label: '1h', value: 60 }, { label: '1h30', value: 90 }, { label: '2h', value: 120 }];

const NewExam = ({
  companyId, semestersList, examData, updateExamData,
}) => {
  const [catchUp, setCatchUp] = useState(false);
  const [modalities, setModalities] = useState([]);
  const [minimumDeliveryDate, setMinimumDeliveryDate] = useState(new Date(today.getFullYear(), today.getUTCMonth(), today.getDate() + 42, 9, 0, 0, 0));
  const [form, setForm] = useState({
    modality: { label: '', value: '' },
    EWCorrect: false,
    beginDate: minDate,
    endDate: maxDate,
    duration: durations[2],
    semester: semestersList[0],
    deliveryDate: minimumDeliveryDate,
  });
  const { addExam } = useExam(companyId, examData, updateExamData);
  const classes = useStyles();

  useEffect(() => {
    if (form.beginDate !== undefined) {
      const tmp = new Date(form.endDate);
      const tmpEnd = new Date(form.endDate);
      const tmpBegin = new Date(form.beginDate);
      tmp.setDate(tmp.getDate() + 21);
      setMinimumDeliveryDate(tmp);
      if (tmpBegin.getDate() > tmpEnd.getDate()) {
        tmpBegin.setHours(tmpBegin.getHours() + 1);
        setForm({ ...form, deliveryDate: tmp, endDate: tmpBegin });
      } else {
        setForm({ ...form, deliveryDate: tmp });
      }
    }
  }, [form.beginDate, form.endDate]);

  useEffect(() => {
    if (form.semester !== undefined) {
      if (form.semester?.examModalities?.length > 0) {
        setForm({ ...form, modality: form.semester.examModalities[0] });
        setModalities(form.semester.examModalities);
      } else {
        setForm({ ...form });
      }
    }
  }, [form.semester]);

  return (
    <div className={classes.root}>
      <Grid container spacing={2} style={{ marginBottom: '15px', alignItems: 'center' }}>
        <Grid item md={3}>
          <Typography
            component="h6"
            variant="h6"
          >
            Examen
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ marginBottom: '15px', alignItems: 'center' }}>
        <Grid item md={3}>
          <Select
            value={form.semester}
            styles={customStyles}
            options={semestersList}
            placeholder="Semestre"
            onChange={(e) => { setForm({ ...form, semester: e }); }}
          />
        </Grid>
        <Grid item md={3} />
        <Grid
          item
          md={2}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <Typography
            variant="body1"
          >
            Rattrapage
          </Typography>
          <Switch
            checked={catchUp}
            onChange={() => { setCatchUp(!catchUp); }}
            name="checkRecurent"
            Gridor="primary"
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ marginBottom: '15px', alignItems: 'center' }}>
        <Grid item md={5}>
          <MuiPickersUtilsProvider utils={MomentUtils} locale="fr">
            <KeyboardDateTimePicker
              required
              inputMode="none"
              InputProps={{ readOnly: true }}
              autoOk
              // error={errors.date}
              disablePast
              minDate={minDate}
              format="DD/MM/YYYY - HH:mm"
              fullWidth
              onChange={(e) => { setForm({ ...form, beginDate: e }); }}
              value={form.beginDate}
              helperText="Date et heure de début de l'examen"
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item md={5}>
          <MuiPickersUtilsProvider utils={MomentUtils} locale="fr">
            <KeyboardDateTimePicker
              required
              autoOk
            //   error={errors.date}
              minDate={form.beginDate || minDate}
              disablePast
              InputProps={{ readOnly: true }}
              format="DD/MM/YYYY - HH:mm"
              fullWidth
              onChange={(e) => { setForm({ ...form, endDate: e }); }}
              value={form.endDate}
              helperText="Date et heure de fin de l'examen"
            />
          </MuiPickersUtilsProvider>
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ alignItems: 'center' }}>
        <Grid item md={2}>
          <Typography
            component="h6"
            variant="body1"
          >
            {(form.semester && form.semester.value === 6) ? 'Modalités de dépôt :' : 'Modalités d\'examen :'}
          </Typography>
        </Grid>
        <Grid item md={4}>
          <Select
            value={form.modality}
            styles={customStyles}
            options={modalities}
            placeholder="Modalité"
            onChange={(e) => { setForm({ ...form, modality: e }); }}
          />
          {(form.modality !== undefined && (form.modality.value === 'Sur la plateforme - Test de placement'
            || form.modality.value === 'Sur la plateforme - Test de connaissance 60 minutes'
            || form.modality.value === 'Sur la plateforme - Test de connaissance 90 minutes'
          ))
            && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'Grid',
                justifyContent: 'center',
                alignItems: 'flex-start',
              }}
            >
              <Typography
                variant="caption"
                style={{
                  color: '#F50057',
                  marginRight: '5px',
                }}
              >
                *
              </Typography>
              <Typography
                variant="caption"
                style={{ color: '#F50057' }}
              >
                Les quiz sont automatiquement corrigés par notre plateforme
              </Typography>
            </div>
            )}
        </Grid>
        <Grid container style={{ marginTop: '15px', marginBottom: '15px' }} spacing={2}>
          <Grid item md={12}>
            <Alert severity="info" style={{ margin: '0px 8px 0px 8px' }}>
              Le service d&apos;assistance téléphonique pour les examens sera disponible du
              {' '}
              <span style={{ fontWeight: '600' }}>lundi au vendredi</span>
              , de
              {' '}
              <span style={{ fontWeight: '600' }}>9h à 17h</span>
              .
            </Alert>
          </Grid>
        </Grid>
        {(form.modality !== undefined
        && form.modality.value !== 'Sur la plateforme - Dépôt de capsule vidéo'
        && form.modality.value !== 'Sur la plateforme - Dépôt de fichier'
        && !form.modality.value.includes('Oral')
        && !form.modality.value.includes('Sur table'))
        && (
          <>
            <Grid item md={2}>
              <Typography
                component="h6"
                variant="body1"
              >
                Durée de l&apos;examen :
              </Typography>
            </Grid>
            <Grid item md={2}>
              <Select
                value={form.duration}
                style={{ width: '100%' }}
                options={durations}
                placeholder="Durée"
                onChange={(e) => { setForm({ ...form, duration: e }); }}
              />
            </Grid>
          </>
        )}
      </Grid>
      <Grid container spacing={2} style={{ marginTop: '15px' }}>
        {
          form.modality
          && (form.modality.value !== 'Sur la plateforme - Test de placement'
            && form.modality.value !== 'Sur la plateforme - Test de connaissance 60 minutes'
            && form.modality.value !== 'Sur la plateforme - Test de connaissance 90 minutes'
          )
            && (
              <Grid item md={4}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Typography
                    component="h6"
                    variant="body1"
                  >
                    Corrigé par EnglishWorld ?
                  </Typography>
                  <Switch
                    checked={form.EWCorrect}
                    onChange={() => { setForm({ ...form, EWCorrect: !form.EWCorrect }); }}
                    name="checkRecurent"
                    Gridor="primary"
                  />
                </div>
                { form.EWCorrect
                  ? (
                    <MuiPickersUtilsProvider utils={MomentUtils} locale="fr" style={{ marginTop: '20px' }}>
                      <KeyboardDatePicker
                        required
                        autoOk
                        inputMode="none"
                        minDate={minimumDeliveryDate}
                        disablePast
                        InputProps={{ readOnly: true }}
                        format="DD/MM/YYYY"
                        fullWidth
                        onChange={(e) => { setForm({ ...form, deliveryDate: e._d }); }}
                        value={form.deliveryDate}
                        helperText="Date de retour des notes"
                      />
                    </MuiPickersUtilsProvider>
                  )
                  : null}
              </Grid>
            )
          }
      </Grid>
      { form.EWCorrect === true
        ? (
          <Grid container spacing={2} style={{ marginTop: '15px' }}>
            <Grid item md={12}>
              <Alert severity="error">
                Attention, le retour des notes se fera minimum
                {' '}
                <span style={{ fontWeight: '600' }}>3 semaines</span>
                {' '}
                après la réalisation de l&apos;examen.
              </Alert>
            </Grid>
          </Grid>
        )
        : null}
      <Grid container style={{ marginTop: '15px' }} spacing={2}>
        <Grid item md={8} />
        <Grid item md={4}>
          <Button
            onClick={() => {
              addExam(form, catchUp);
              updateExamData();
            }}
            style={{ marginTop: '1.5em', padding: '1em 0 1em 0' }}
            variant="contained"
            color="primary"
            fullWidth
          >
            + Ajouter
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

NewExam.propTypes = {
  companyId: PropTypes.string.isRequired,
  semestersList: PropTypes.array.isRequired,
  examData: PropTypes.array.isRequired,
  updateExamData: PropTypes.func.isRequired,
};

export default NewExam;
